import { useMutation, useQueryClient } from '@tanstack/react-query'
import { syncBank } from '../../services'
import { toast } from 'sonner'
import { BankQueryKeys } from '@/modules/bank/keys'

export default function useMutationSyncBank() {
	const queryClient = useQueryClient()

	return useMutation({
		mutationFn: syncBank,
		onSuccess: () => {
			queryClient.invalidateQueries({
				queryKey: [BankQueryKeys.BankAccounts],
			})
			toast.success('sync Bank สำเร็จ')
		},
	})
}
